import { useState as i, useEffect as c } from "react";
import { useSelector as m, useDispatch as u } from "react-redux";
import { setUser as a } from "../services/DataStoreService/reducers/AppReducer.js";
import { exponentialBackoff as f } from "../utils/async.js";
import p from "../services/ApiService.js";
import { makeAbortablePromise as l } from "../utils/promises.js";
function b() {
  const { user: t } = m((e) => e.app.datastate), r = u(), [s, o] = i([]);
  return c(() => {
    if (t?._id == null) return;
    const e = new AbortController();
    return f(
      () => d(t._id, t.userToken, e.signal),
      { maxRetries: 3 }
    ).then((n) => {
      r(a({ ...t, userToken: n?.refreshedToken })), r(a({ ...t })), o(n.payload);
    }).catch((n) => {
    }), () => {
      o([]), e?.abort();
    };
  }, [t?._id]), s;
}
async function d(t, r, s) {
  const { status: o, data: e } = await l(() => p(r).GetPatient({ ownerUserId: t }), s);
  if (!o.toString().match(/^2/)) throw new Error(e.message ?? "Failed to get patients");
  return e;
}
export {
  b as default
};
